export default "__VITE_ASSET__CEAAL6M2__"